import { Wording } from '@/types';

export const ASTROLOGY_WORDING_FR: Wording = {
  components_header_media_content: 'Audios',
  components_header_media_1: 'Méditations',
  components_header_media_2: 'Podcast',
  components_header_text1: 'Guides',
  components_header_text2: 'Blog',
  components_header_members: 'Membres',
  hero_text: 'Explorez les étoiles intérieures',
  hero_button_text: 'Commencez ici',
  components_ressources_section_title: 'RESSOURCES',
  components_ressources_subheader_text: 'Tous les outils dont vous avez besoin pour une vision cosmique et une découverte de soi',
  components_ressources_span_text: 'Élargissez votre univers intérieur grâce à une sélection soignée de podcasts et d\'articles. Que vous recherchiez une vision cosmique, une clarté ou un alignement spirituel, nos ressources vous aident à vous connecter à l\'astrologie de manière pratique et significative.',
  components_ressources_card_1_title: 'Plongées profondes',
  components_ressources_card_1_text: 'Plongez dans une riche collection de podcasts approfondis couvrant l\'astrologie, le tarot, les archétypes cosmiques et la croissance spirituelle, conçus pour élargir votre conscience et approfondir votre pratique.',
  components_ressources_card_2_title: 'Star Insights',
  components_ressources_card_2_text: 'Conseils astrologiques et articles de blog pour la conscience de soi et la croissance spirituelle.',
  components_ressources_link: 'Explorer plus loin',
  components_notes_and_google_title_1: 'Guidance astrologique',
  components_notes_and_google_title_2: 'Routine cosmique',
  components_notes_and_google_title_3: 'Réflexions',
  components_review_google_text: 'Avis',
  media_content_section_title: 'AUDIOS',
  media_content_section_subheader_text: 'Notre podcast',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Plus d\'épisodes',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: 'Articles et réflexions',
  text2_section_button_more: 'Charger plus',
  components_text1_section_title: 'GUIDES',
  components_text1_subheader_text: '',
  components_text1_span_text: '',
  components_text1_card_1_title: '',
  components_text1_card_1_text: '',
  components_text1_card_3_title: '',
  components_text1_card_3_text: '',
  components_text1_card_2_title: '',
  components_text1_card_2_text: '',
  components_text1_link: 'Voir tous les guides',
  components_footer_text: 'Réveillez votre cosmos intérieur : votre chemin, vos étoiles.',
  components_footer_info: 'Informations',
  components_footer_registration_number: 'Numéro d\'enregistrement',
  components_footer_legal: 'Légal',
  components_footer_terms: 'Termes et conditions',
  components_footer_privacy: 'politique de confidentialité',
  button_load_more: 'Charger plus',
  page_media_1_content_hero_text: 'Épisodes de podcast',
  page_media_content_menu_foundations: 'Fondations',
  page_media_content_menu_spirituality: 'Spiritualité',
  page_media_content_menu_tarot: 'Tarot',
  page_media_content_menu_psychology: 'Psychologie',
  page_media_content_menu_trends: 'Tendances',
  page_media_2_content_hero_text: 'Médias 2',
  page_text1_hero_text: '',
  page_text1_section_title: '',
  page_text1_subheader_text: '',
  page_text2_hero_text: 'Notre blog',
  page_text2_section_title: 'Blog',
  page_text2_subheader_text: 'Articles et réflexions',
  enter_email_title: 'Veuillez entrer votre email pour continuer',
  enter_email_placeholder_email: 'E-mail',
  enter_email_button_enter: 'Entrer',
  components_login_success_text: 'Connexion réussie !',
  components_card_link_media_content: 'Écoutez maintenant',
  components_card_link_text1_content: 'Voir le guide',
  components_card_link_text2_content: 'Voir l\'article',
  france: 'France',
  cyprus: 'Chypre',
  tag_podcast: 'Podcast',
  tag_meditation: 'Méditation',
  page_media_content_menu_all: 'Tous',
};